<template>
    <div>
        <router-link :to="'/shareholder/update/' + row.id" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
            <i class="fas fa-edit"></i>
        </router-link>
    </div>
</template>

<script>
    import Vue from 'vue';

    export default Vue.extend({
        props: {
            row: {
                required: true,
            },
            index: {
                required: true,
            },
            datatable: {
                required: true,
            },
        },
    })
</script>
